import { Type } from '@sinclair/typebox';
export var SyncResources;
(function (SyncResources) {
    SyncResources["Accounts"] = "accounts";
    SyncResources["SupplierInvoices"] = "supplier-invoices";
    SyncResources["CustomerInvoices"] = "customer-invoices";
    SyncResources["Projects"] = "projects";
})(SyncResources || (SyncResources = {}));
export const ListSyncStatusSchema = Type.Object({
    resource: Type.String(),
    lastSync: Type.String(),
});
export const GetSyncStatusResponseSchema = Type.Array(ListSyncStatusSchema);
